import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-dynamic-object-builder",
  templateUrl: "./dynamicObjectBuilder.html",
  styleUrls: ["./dynamicObjectBuilder.scss"]
})
export class DynamicObjectBuilderComponent implements OnInit {
  keyValuePairs = [{ key: "", value: "" }];
  @Input() meta_data: any = {};
  object: any = {};

  @Output() constructValue = new EventEmitter();

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["meta_data"].currentValue) {
      this.generateValue();
    }
  }

  ngOnInit(): void {}
  generateValue = () => {
    let val: any = [];
    if (Object.keys(this.meta_data).length !== 0) {
      this.object = { ...this.meta_data };
      for (const key in this.meta_data) {
        val.push({ key, value: this.meta_data[key] });
      }
      this.keyValuePairs = val;
      this.buildObject(false);
    }
  };

  addPair() {
    this.keyValuePairs.push({ key: "", value: "" });
  }

  removePair(index: number) {
    this.keyValuePairs.splice(index, 1);
    this.buildObject();
  }

  buildObject(submit = true) {
    this.object = {};
    this.keyValuePairs.forEach((pair) => {
      if (pair.key.trim()) {
        this.object[pair.key] = pair.value;
      }
    });

    submit && this.constructValue.emit(this.object);
  }
  sanitizeKey(value: string): string {
    return value.toLowerCase().replace(/[^a-z0-9]/g, "");
  }
  onKeyChange(index) {
    this.keyValuePairs[index].key = this.sanitizeKey(this.keyValuePairs[index].key);
    this.buildObject();
  }
  filterKey(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9]$/;

    // Obtiene el carácter presionado
    const key = event.key;

    // Permitir teclas especiales como backspace, tab, etc.
    const specialKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];

    if (
      specialKeys.indexOf(key) === -1 && // Si no es tecla especial
      !allowedRegex.test(key) // Y no es letra o número
    ) {
      event.preventDefault(); // Bloquea el carácter
    }
  }
}
